export const ALHeaderElements = [
  { label: "N° de Cuenta", value: "nroCuenta", align: "inherit" },
  { label: "Zona Comercial", value: "zonaComercial", align: "inherit" },
  { label: "Localidad", value: "localidad", align: "inherit" },
  { label: "Razón Social", value: "razonSocial", align: "inherit" },
  { label: "Tipo de Cuenta", value: "tipoDeCuenta", align: "inherit" },
  { label: "Control de Saldos", value: "controlDeSaldos", align: "center" },
];
